import "./FloatingPhoneButton.scss";

export default function FloatingPhoneButton() {
  return (
    <div className="floating-phone-button">
      <a href="tel:+359885777310">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="34"
          height="33"
          viewBox="0 0 34 33"
          fill="none"
        >
          <path
            d="M4.17962 4.43149L6.904 1.70711C7.29453 1.31658 7.92769 1.31658 8.31822 1.70711L14.0151 7.404C14.4056 7.79453 14.4056 8.42769 14.0151 8.81822L11.6498 11.1836C11.3613 11.4721 11.2897 11.9128 11.4722 12.2777C13.5818 16.497 17.003 19.9182 21.2223 22.0278C21.5872 22.2103 22.0279 22.1387 22.3164 21.8502L24.6818 19.4849C25.0723 19.0944 25.7055 19.0944 26.096 19.4849L31.7929 25.1818C32.1834 25.5723 32.1834 26.2055 31.7929 26.596L29.0685 29.3204C26.9572 31.4317 23.6146 31.6693 21.2259 29.8777L13.7952 24.3048C12.0517 22.9971 10.5029 21.4483 9.19524 19.7048L3.62226 12.2741C1.83072 9.88541 2.06827 6.54284 4.17962 4.43149Z"
            stroke="#343434"
            strokeWidth="2"
          />
        </svg>
      </a>
    </div>
  );
}
